import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";
import * as Yup from "yup";
import { toast } from "react-toastify";

const AddCoordinate = ({
    AddCoordinateMutate,
    AddCoordinateLoading,
    setAddCoordinate,
  selectedData,
}) => {
  const SubmitHandler = (values) => {
    if (!values.longitude) {
      toast.error("Please enter your Longitude");
      return;
    }else if(!values.latitude) {
      toast.error("Please enter your Latitude");
      return;
    }
    AddCoordinateMutate(values);
  };
  

  const formik = useFormik({
    initialValues: {
      longitude: selectedData?.longitude || "",
      latitude: selectedData?.latitude || "",
        id: selectedData?.id || "",
        clientId: selectedData?.clientId || "",
    },
    validationSchema: Yup.object().shape({
      longitude: Yup.string().required("Longitude is required"),
      latitude: Yup.string().required("Latitude is required")
    }),
    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setAddCoordinate}>
      {AddCoordinateLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Edit Coordinates</Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="longitude">Longitude</Label>
                  <FieldWrapper>
                    <Input
                      type="float"
                      name="longitude"
                      id="longitude"
                      autoComplete="off"
                      value={formik.values.longitude}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.longitude && formik.errors.longitude && (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.longitude}
                      </p>
                    )}
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="latitude">Latitude </Label>
                  <FieldWrapper>
                  <Input
                      type="float"
                      name="latitude"
                      id="latitude"
                      autoComplete="off"
                      value={formik.values.latitude}
                      onChange={formik.handleChange}
                    />
                   {formik.touched.latitude && formik.errors.latitude && (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.latitude}
                      </p>
                    ) }
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default AddCoordinate;
